import { Card } from "antd";
import "./card.scss";

export default Card;
